module.exports = __webpack_public_path__ + "1c0ec11161573cf1445d13d7c117f605.png";